import { isOriginFlow } from "~/tools/funnelUtils";
import useGetLoyaltyRewardFromOffer from "~/clientState/hooks/useGetLoyaltyRewardFromOffer";
import useGetTripInformationQuery from "~/clientState/hooks/useGetTripInformationQuery";
import useUserAccount from "~/clientState/hooks/useUserAccount";

interface IsLoyaltyRewardOnPrimeFirst {
  isLoyaltyRewardOnPrimeFirst: boolean;
  isLoyaltyRewardProgramIncluded: boolean;
  hasLoyaltyRewards: boolean;
  isPrimeBooking: boolean;
  buyerInformation?: BuyerInformation;
}

interface BuyerInformation {
  mail: string;
  name: string;
  lastNames?: string;
}

export const useIsLoyaltyRewardOnPrimeFirst =
  (): IsLoyaltyRewardOnPrimeFirst => {
    const isUserFromPayment = isOriginFlow();
    const { isLoyaltyRewardProgramIncluded, hasLoyaltyRewards } =
      useGetLoyaltyRewardFromOffer();
    const {
      data: tripData,
      loading: tripLoading,
      errors: tripErrors,
    } = useGetTripInformationQuery();
    const { data: userAccountData } = useUserAccount();
    const isLoggedIn = userAccountData?.userAccount?.isLoggedIn || false;
    const isPrimeMember =
      userAccountData?.userAccount?.userMembership.isActive ||
      tripData?.getTrip?.userMembership?.isActive ||
      false;

    const isPrimeBooking =
      (tripData?.getTrip?.trip?.prime ||
        tripData?.getTrip?.trip?.primeMembershipContracted) ??
      false;

    const isLoyaltyRewardOnPrimeFirst =
      !isPrimeMember &&
      !isLoggedIn &&
      hasLoyaltyRewards &&
      isPrimeBooking &&
      isUserFromPayment;

    const buyerInformation: BuyerInformation | undefined = (():
      | BuyerInformation
      | undefined => {
      if (tripLoading || tripErrors || !tripData?.getTrip?.trip?.buyer) {
        return undefined;
      }

      const { mail, name, lastNames } = tripData.getTrip.trip.buyer;
      return {
        mail,
        name,
        lastNames: lastNames ?? undefined,
      };
    })();

    return {
      isLoyaltyRewardOnPrimeFirst,
      isLoyaltyRewardProgramIncluded,
      hasLoyaltyRewards,
      isPrimeBooking,
      buyerInformation,
    };
  };

export default useIsLoyaltyRewardOnPrimeFirst;
